<template>
  <v-menu flat>
    <v-btn
      slot="activator"
      flat
    >
      <span
        class="title"
      >{{ user.username }}</span>
      <v-icon dark>
        arrow_drop_down
      </v-icon>
    </v-btn>
    <v-list>
      <v-list-tile @click="logout">
        <v-list-tile-title>
          <span>Logout</span>
        </v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'UserDropdown',
  computed: mapGetters({
    user: 'auth/user'
  }),
  methods: {
    async logout () {
      // Log out the user.
      await this.$store.dispatch('auth/logout')

      // Redirect to login.
      this.$router.push({ name: 'login' })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/components/UserDropdown.vue